import { action } from 'typesafe-actions';

import { IFilterResult } from 'APIPackage/MainModule/interfaces/IFilterResult';

import { DecisionListFilterActionsEnum } from '../enums/DecisionListFilterActionsEnum';
import { IDecisionListFilter } from '../interfaces/IDecisionListFilter';

export interface IDecisionListFilterSetCurrentParams {
  current?: IDecisionListFilter;
  currentId?: IFilterResult['id'];
}

export const decisionListFilterInit = (filterType?: string) =>
  action(DecisionListFilterActionsEnum.DECISION_LIST_FILTER_INIT, { filterType });
export const decisionListFilterSetSwitcher = (value: boolean) =>
  action(DecisionListFilterActionsEnum.DECISION_LIST_FILTER_SET_SWITCHER, { value });
export const decisionListFilterSetCurrent = ({ current, currentId }: IDecisionListFilterSetCurrentParams) =>
  action(DecisionListFilterActionsEnum.DECISION_LIST_FILTER_SET_CURRENT, { current, currentId });
export const decisionListFilterGetMeta = (filterType?: string) =>
  action(DecisionListFilterActionsEnum.DECISION_LIST_FILTER_GET_META, { filterType });
export const decisionListFilterSetMeta = (list: IFilterResult[]) =>
  action(DecisionListFilterActionsEnum.DECISION_LIST_FILTER_SET_META, { list });
export const decisionListFilterGetData = (id: IFilterResult['id']) =>
  action(DecisionListFilterActionsEnum.DECISION_LIST_FILTER_GET_DATA, { id });
export const decisionListFilterSetData = (id: IFilterResult['id'], data: IDecisionListFilter) =>
  action(DecisionListFilterActionsEnum.DECISION_LIST_FILTER_SET_DATA, { id, data });
export const decisionListFilterCreate = (data: IDecisionListFilter) =>
  action(DecisionListFilterActionsEnum.DECISION_LIST_FILTER_CREATE, { data });
export const decisionListFilterUpdate = (id: IFilterResult['id'], data: IDecisionListFilter) =>
  action(DecisionListFilterActionsEnum.DECISION_LIST_FILTER_UPDATE, { id, data });
export const decisionListFilterRemove = (id: IFilterResult['id']) =>
  action(DecisionListFilterActionsEnum.DECISION_LIST_FILTER_REMOVE, { id });
export const decisionListFilterSetCurrentControlOrganizations = (ids: string[]) =>
  action(DecisionListFilterActionsEnum.DECISION_LIST_FILTER_SET_CURRENT_CONTROL_ORGANIZATIONS, { ids });
export const decisionListFilterSetCurrentSupervisionTypes = (ids: string[]) =>
  action(DecisionListFilterActionsEnum.DECISION_LIST_FILTER_SET_CURRENT_SUPERVISION_TYPES, { ids });
